<template>
  <!-- Content Wrapper. Contains page content -->

  <div class="content-wrapper">
    <!--        <preLoader v-if="loader"></preLoader>-->
    <div class="container-fluid">
      <br/>
      <br/>
    </div>
    <span id="mintime" style="display:none">{{ new Date() | moment("jYYYY/jMM/jDD") }}</span>

    <section class="content">


      <div class="row">

        <div class="col-md-12 col-sm-12 p-3  mb-3" style="background-color: white">
          <div class="box-o box-primary pb-5" style="overflow-x: auto; direction: rtl;text-align: right ">

            <table  style="text-align: right;" class="table table-hover table-striped table-sm">

              <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">نام محصول</th>
                <th scope="col">کد محصول</th>

                <th scope="col">واحد</th>
                <th scope="col">کد واحد</th>

                <th scope="col">مقدار/تعداد</th>
                <th scope="col">قیمت واحد</th>
                <th scope="col">تخفیف</th>
                <th scope="col">درصد مالیات</th>
                <th scope="col" >قیمت کل</th>
              </tr>
              </thead>


              <tbody>


              <tr id="orderProducts" v-for="(item, orderProductIndex) in order.items"
                  style="background-color: #cfcfcf;color: #222; " class="mb-5">
                <!-- {{  | json }}

                                                                                    :checked="item.state = 1"
                -->
                <td>

                  <button class="btn btn-dark btn-sm" type="button"
                          v-on:click="removeProduct(item.id)">
                    <i class="fa fa-trash"></i>
                  </button>


                </td>

                <td title="عنوان محصول ">

                  <!--                                    <small  v-text="accountingCodeShowName(item.accounting_code_id)" >-->

                  <!--                                    </small>-->

                  <!--                                      <v-select-->
                  <!--                                              v-model="item.accounting_code_id" class="form-control-sm mt-0 pt-0"  style="min-width: 90px"-->
                  <!--                                              :options="accountingCodes" label="code" :reduce="accountingCode => accountingCode.id" value="id">-->
                  <!--                                      </v-select>-->

                  <input class="form-control form-control-sm" style="min-width: 70px" v-model="item.product.name"
                         type="text" data-type="text">
                </td>


                <td title=" کد محصول" class="">
                  <input class="form-control form-control-sm" style="min-width: 20px" v-model="item.product.code"
                         type="number" data-type="text">
                </td>


                <td title="واحد">
                  <input class="form-control form-control-sm" style="min-width: 10px" v-model="item.product.unit.name"
                         type="text" data-type="text">
                </td>
                <td title="کد واحد">
                  <input class="form-control form-control-sm" style="min-width: 5px" v-model="item.product.unit.code"
                         type="number" data-type="text">
                </td>





                <td title="مقدار/تعداد">
                  <input class="form-control form-control-sm" style="width: 90px" v-model="item.amount"
                         type="number" data-type="number">
                </td>


                <td title="قیمت واحد">
                  <input class="form-control form-control-sm" style="width: 90px"
                         v-model="item.price"
                         type="number" data-type="number">
                </td>

                <td title="تخفیف">
                  <input class="form-control form-control-sm" style="min-width: 10px" v-model="item.discount"
                         type="number" data-type="text">
                </td>
                <td title="درصد مالیات (بین ۰ تا ۱)">
                <input class="form-control form-control-sm" style="min-width: 20px" v-model="item.tax"
                       type="number" data-type="text">
              </td>

                <td class="mailbox-subject">
                  <b>{{
                      spliceNumber(item.price * item.amount)
                    }} {{ $curency }}  </b>
<!--                                                                <span-->
<!--                                                                      :id="`showInput`+item.id" style="display:none">-->
<!--                                                                    <input disabled-->
<!--                                                                           class="form-control  form-control-sm"-->
<!--                                                                           v-model="item.price*item.amount"-->
<!--                                                                           item.price type="number" data-type="number">-->
<!--                                                                    <b @click="hideInput(item.id)">-->
<!--                                                                        <i class="fa fa-times" aria-hidden="true"></i>-->
<!--                                                                    </b>-->
<!--                                                                </span>-->
<!--                  <span @click="inputEdit(item.id)">-->
<!--                                                                    <b>{{-->
<!--                                                                        spliceNumber(item.price * item.amount)-->
<!--                                                                      }} {{ $curency }}  </b>-->

<!--                                                            </span>-->


                </td>
                <!--<td class="mailbox-date">-->
                <!--<input class="form-control" v-model="item.number"-->
                <!--type="number" data-type="number" min="1" style="width: 70px">-->
                <!--</td>-->

<!--                <td>-->
<!--                  <custom-time-picker v-model="item.end" :clearable="true"-->
<!--                                      placeholder="Expire Date"-->
<!--                                      format="jYYYY/jMM/jDD" min="" max="">-->
<!--                  </custom-time-picker>-->
<!--                </td>-->

              </tr>


              <tr id="orderServices" v-for="(item, orderServicesIndex) in order.services"
                  :title="item.note" style="background-color: #26a69a;color: white" class="mb-5">
                <!-- {{  | json }}

                                                                                    :checked="item.state = 1"
                -->
                <td>

                  <div>
                    <!--v-for="(item.order.services , index) in servies" :key="index"

                      :disabled="end_time == '' "

                     -->


                    <button class="btn btn-dark  btn-sm" type="button"
                            v-on:click="removeService(item.item)">
                      حذف
                    </button>
                    <!--<input type="checkbox"-->
                    <!--class="option-input checkbox "-->
                    <!--style="z-index: 0!important;"-->
                    <!--v-on:click="addService(item.id, default_person, item.max_time ,$event, item.price, item.title, item.number, item)" />-->
                    &ensp;&ensp;
                    <!-- {{ order.servies.check }} -->
                    <!--{{ item.note }}-->

                  </div>


                </td>


                <td>

                  <!--                                    <small  v-text="accountingCodeShowName(item.accounting_code_id)" >-->

                  <!--                                    </small>-->


                </td>
                <td class="" colspan="3">
                  <!--                                    <v-select-->
                  <!--                                            v-model="item.accounting_code_id" class="form-control-sm  mt-0 pt-0"-->
                  <!--                                            :options="accountingCodes" label="title" :reduce="accountingCode => accountingCode.id" value="id">-->
                  <!--                                    </v-select>-->
                  <!--                                                            <b-form-select v-model="item.accounting_code_id" >-->
                  <!--                                                                <b-form-select-option v-for="(accountingCode, accountingCodeIndex) in accountingCodes" :key="accountingCodeIndex" :value="accountingCode.id">-->
                  <!--                                                                    {{accountingCode.code+'-'+accountingCode.title}}-->
                  <!--                                                                </b-form-select-option>-->

                  <!--                                                            </b-form-select>-->

                </td>


                <td title="عنوان">
                  <span v-text="serviceShowName(item.service_id)"></span>
                </td>

                <td colspan="3" class="mailbox-date">
                  <input class="form-control form-control-sm " v-model="item.note"
                         type="text" data-type="text">
                </td>

                <!--
                                               <td class="mailbox-date">


                                                   <div class="dropdown" style="color: #000!important;">
                                                      <button
                                                               class="btn btn-secondary btn-sm  dropdown-toggle"
                                                               type="button" id="dropdownMenuButton1"
                                                               data-toggle="dropdown" aria-haspopup="true"
                                                               aria-expanded="false"
                                                       >
                                                           کارمند/پیمانکار
                                                       </button>

                        <div class="dropdown-menu"
                             style="text-align: center; "
                             aria-labelledby="dropdownMenuButton">

                            <section>
                                <form>

                                    <ul class="nav ">
                                       </ul>

                                </form>
                            </section>





                        </div>
                    </div>
                </td>
-->


                <td class="mailbox-date" title="قیمت">
                  <input v-if="$store.state.access" class="form-control form-control-sm " style="width: 170px"
                         v-model="item.price"
                         type="number" data-type="number">
                </td>


                <td colspan="1" class="mailbox-subject">
                                                                <span v-if="$store.state.access"
                                                                      :id="`showInput`+item.id" style="display:none">
                                                                    <input class="form-control" v-model="item.price"
                                                                           type="number" data-type="number">
                                                                    <b @click="hideInput(item.id)">
                                                                        <i class="fa fa-times-circle-o"
                                                                           aria-hidden="true"></i>
                                                                    </b>
                                                                </span>
                  <span @click="inputEdit(item.id)">
                                                                    <b v-if="$store.state.access">{{
                                                                        spliceNumber(item.price)
                                                                      }} {{ $curency }}  </b>

                                                            </span>


                </td>


                <!--<td class="mailbox-date">-->
                <!--<input class="form-control" v-model="item.number"-->
                <!--type="number" data-type="number" min="1" style="width: 70px">-->
                <!--</td>-->
                <td></td>

              </tr>


              </tbody>
            </table>
            <small class="m-2">فیلد درصد مالیات بین ۰ تا ۱ وارد شود.</small>

          </div>
          <button class="btn btn-info btn-xd" type="button"
                  v-on:click="addProductEmpty()">
            <i class="fa fa-plus"></i>
            افزودن آیتم فاکتور
          </button>
        </div>

        <div class="col-md-4 col-sm-12 p-3 box-o" style="background-color: white; text-align: right">
          <div class="box box-primary">
            <div class="box-header" style="background-color: #00acc1;color: #fff">
              <!--                                <h3 class="box-title"> {{ $t('reservation date') }}<small></small></h3>-->
            </div>
            <div class="box-body  mt-1 mb-4">


              <h5 class=" form-group text-center">

                <!--                                    جمع خدمات انتخابی:-->
                <!--                                    <span style="color: #8e24aa"> {{spliceNumber(totalSum(order.services))}} </span>-->
                <!--                                    {{$curency}}-->
                <!--                                    <br>-->

                <!--                                    جمع کالا ها انتخابی:-->
                <!--                                    <span style="color: #0097a7"> {{spliceNumber(totalSum(order.products))}} </span>-->
                <!--                                    {{$curency}}-->
                <!--                                    <hr>-->
                جمع کل:
                <span style="font-weight: bold"> {{ spliceNumber(totalSum(order.services) + totalSumWithAmount(order.products)) }} </span>

                {{ $curency }}
              </h5>




<!--              <div class="form-group mt-2">-->
<!--                <label>-->
<!--                  &lt;!&ndash;                                        {{ $t('Username') }} &ndash;&gt;-->
<!--                  {{ $client }}/{{ $seller }}-->
<!--                </label>-->
<!--                <div v-if="contactInfo.contact">{{ contactInfo.contact.first_name }}-->
<!--                  {{ contactInfo.contact.last_name }}-->
<!--                </div>-->


<!--                <div v-else>-->
<!--                  &lt;!&ndash;                                        <b-form-select v-model="order.user_id"  size="sm" class="mt-2"  style="direction: ltr">&ndash;&gt;-->
<!--                  &lt;!&ndash;                                            <b-form-select-option  v-for="(contact, contactIndex) in contacts" :key="contactIndex"  :value="contact.user_id" >{{contact.first_name+' '+contact.last_name}}</b-form-select-option>&ndash;&gt;-->
<!--                  &lt;!&ndash;                                        </b-form-select>&ndash;&gt;-->

<!--                  <v-select-->
<!--                      v-model="order.user_id" @change="updateVendorData"-->
<!--                      :options="contacts" label="last_name" :reduce="contact => contact.user_id" value="user_id">-->
<!--                  </v-select>-->


<!--                  &lt;!&ndash;                            <multiselect  v-model="contact_id"  @select="setContactId()"    :options="contactOptions" :custom-label="customLabel"&ndash;&gt;-->
<!--                  &lt;!&ndash;                                         placeholder=" انتخاب مشتری" label="title" track-by="title">&ndash;&gt;-->
<!--                  &lt;!&ndash;                            </multiselect>&ndash;&gt;-->
<!--                </div>-->


<!--              </div>-->


              <div class="form-group">
                <label>
                  <!--                                        {{ $t('Choose date') }} -->
                  تاریخ  فاکتور
                </label>
                <div class="">
                  <!-- <div class="input-group-addon">
                  <i class="fa fa-calendar"></i>
              </div> -->

                  <!--<input v-model="order.date" type="text" id="tarikh" class="form-control pull-right">-->
                  <!--<input type="text" id="tarikhAlt" class="form-control pull-right">-->

                  <custom-time-picker v-model="order.factorDate" :clearable="true"
                                      placeholder="تاریخ را انتخاب کنید" :color="colors[activeColorIndex]"
                                      format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD" min="" max="" @change="parentSetData()">
                  </custom-time-picker>
                  <!-- <button type="button" @click="submit">Post</button> -->
                </div>
                <!-- /.input group -->
              </div>


              <div class=" form-group">
                <label class="control-label"> شماره فاکتور
                </label>
                <input type="number" v-model="order.code"  class="form-control">
              </div>



              <div class=" form-group p-2">
                <label class="control-label"> نوع فاکتور
                </label>
                <b-form-select v-model="order.state">

                  <b-form-select-option value="type1">
                    نوع اول
                  </b-form-select-option>
                  <b-form-select-option value="type2">
                    نوع دوم
                  </b-form-select-option>

                </b-form-select>
              </div>


              <div v-if="order.state != 'type2'" class=" form-group p-2" style="background-color: #e2e2e2">
                <label class="control-label"> نام خریدار
                </label>
                <input type="text" v-model="order.buyer.note"  class="form-control">
              </div>
              <div v-if="order.state != 'type2'"  class=" form-group p-2" style="background-color: #e2e2e2">
                <label class="control-label"> نوع خریدار
                </label>
                <b-form-select v-model="order.buyer.buyerType">

                  <b-form-select-option value="legal">
                    حقوقی
                  </b-form-select-option>
                  <b-form-select-option value="person">
                    حقیقی
                  </b-form-select-option>

                </b-form-select>
              </div>
              <div v-if="order.state != 'type2'"  class=" form-group p-2" style="background-color: #e2e2e2">
                <label class="control-label"> شناسه‌ملی خریدار
                </label>
                <input type="text" v-model="order.buyer.nationalCode"  class="form-control">
              </div>
              <div v-if="order.state != 'type2'"  class=" form-group p-2" style="background-color: #e2e2e2">
                <label class="control-label"> کدپستی خریدار
                </label>
                <input type="text" v-model="order.buyer.postCode"  class="form-control">
              </div>


              <div class=" form-group">
                <label class="control-label">نوع پرداخت
                  <!--                                        {{ $t('Status description') }}:-->
                </label>
                <!--                                    <input type="text" v-model="order.description" :placeholder="$t('Description')" class="form-control">-->
                <b-form-select v-model="order.payType">

                  <b-form-select-option value="cash">
                   نقدی
                  </b-form-select-option>
                  <b-form-select-option value="credit">
                     نسیه
                  </b-form-select-option>

                </b-form-select>

              </div>


              <div class=" form-group">
                <label class="control-label"> مبلغ پرداخت شده
                </label>
                <input type="number" v-model="order.payed"  class="form-control">
              </div>





              <div class=" form-group p-2" style="background-color: #e2e2e2">
                <label class="control-label"> الگوی فاکتور
                </label>
                <b-form-select v-model="order.pattern">

                  <b-form-select-option value="pattern1">
                    الگوی ۱ (فروش)
                  </b-form-select-option>
                  <b-form-select-option value="pattern4">
                    الگوی ۴ (پیمانی)
                  </b-form-select-option>

                </b-form-select>
                <div  v-if="order.pattern == 'pattern4'"  class="mt-3 form-group">
                  <label class="control-label"> شماره قرارداد
                  </label>
                  <input type="text" v-model="order.contractId"  class="form-control">
                </div>
              </div>






<!--              <div v-if="order.factor_type == 1" class=" form-group">-->
<!--                <label class="control-label">وضعیت فاکتور-->
<!--                  &lt;!&ndash;                                        {{ $t('Status description') }}:&ndash;&gt;-->
<!--                </label>-->
<!--                &lt;!&ndash;                                    <input type="text" v-model="order.description" :placeholder="$t('Description')" class="form-control">&ndash;&gt;-->
<!--                <b-form-select v-model="order.factor_state">-->
<!--                  <b-form-select-option value="1">-->
<!--                    پیش فاکتور-->
<!--                  </b-form-select-option>-->
<!--                  <b-form-select-option value="2">-->
<!--                    فاکتور-->
<!--                  </b-form-select-option>-->

<!--                </b-form-select>-->

<!--              </div>-->



              <div class=" form-group">
                <label class="control-label"> شرح
                  <!--                                        {{ $t('Status description') }}:-->
                </label>
                <textarea rows="1" v-model="order.note" :placeholder="$t('Description')"
                          class="form-control"></textarea>


              </div>

              <br>


              <button class="btn btn-block btn-success mb-1 " type="button" @click="savequick()">
                <!--                                    {{ $t('Instant reservation') }}( {{ $t('Between time') }})-->
                ثبت پیش فاکتور/فاکتور

              </button>

              <!--<button type="button" data-toggle="modal" data-target="#timingModal"
                  class="btn btn-block  btn-default"> {{ $t('Reserved times') }}  {{order.date}}</button>

              <br>
              <br>

              -->
              <br>


              <!--

              <div v-for="service of order.services" class="text-danger">


                  <div class=" form-group">
                      <label class="control-label">{{ $t('Name and Description') }}
                      </label>
                      <input type="text" v-model="service.note" class="form-control">
                  </div>

                  <div class="form-group">
                      <label class="control-label"> {{ $t('Price(toman)') }} ({{spliceNumber(service.price)}} {{$curency}})
                      </label>
                      <input type="number" v-model="service.price" class="form-control">
                  </div>
                  <hr>


              </div>

              <div v-for="service of order.products" class="text-danger">

                  <div class="form-group">
                      <label class="control-label"> {{ $t('Name and Description') }}
                      </label>
                      <input type="text" v-model="service.note" class="form-control">
                  </div>

                  <div class="form-group ">
                      <label class="control-label">  {{ $t('Price(toman)') }} ({{spliceNumber(service.price)}} {{$curency}})
                      </label>
                      <input type="number" v-model="service.price" class="form-control">
                  </div>

                  <hr>

              </div>

              <hr>

              <div class=" form-group">

                   جمع خدمات انتخابی:
                  <span style="color: #8e24aa"> {{spliceNumber(totalSum(order.services))}} </span>
                  {{$curency}}
                  <br>

                  جمع کالا ها انتخابی:
                  <span style="color: #0097a7"> {{spliceNumber(totalSum(order.products))}} </span>
{{$curency}}
                  <hr>
                  جمع کل:
                  <span style="font-weight: bold"> {{spliceNumber(totalSum(order.services)+totalSumWithAmount(order.products))}} </span>

{{$curency}}
              </div>

              <button class="btn btn-block btn-success " type="button" @click="savequick()">
                  ثبت پیش فاکتور/فاکتور

              </button>

              -->

            </div>


          </div>
          <!-- /.box -->


          <!-- /.box -->


        </div>


        <div class="col-md-8 col-sm-12 box-o ">
          <div class="box box-primary">


            <div class="nav-tabs-custom">
              <ul class="nav nav-tabs">
<!--                <li class=""><a class="btn btn-outline-info m-2 " href="#tab_1" data-toggle="tab"> لیست خدمات </a></li>-->
<!--                <li class=""><a class="btn btn-outline-primary m-2  active" href="#tab_2" data-toggle="tab"> لیست کالا-->
<!--                  ها</a></li>-->
<!--                <li v-if="order.factor_type == 2 && order.user_id" class=""><a class="btn btn-outline-primary m-2  "-->
<!--                                                                               href="#tab_3" data-toggle="tab">محصولات-->
<!--                  تولیدکننده</a></li>-->

<!--                <li class="float-left">-->
<!--&lt;!&ndash;                  <router-link :to="{path: '/product/create'}" class="btn btn-outline-success float-left m-2">افزودن&ndash;&gt;-->
<!--&lt;!&ndash;                    پارت کالا (ثبت اولیه انبار)&ndash;&gt;-->
<!--&lt;!&ndash;                  </router-link>&ndash;&gt;-->
<!--                </li>-->


              </ul>

              <div class="tab-content">
                <div class="tab-pane " id="tab_1">

                  <div class="box-header with-border">
                    <h4 class="box-title"> افزودن آیتم خدمات:
                    </h4>

                    <div class="box-tools pull-right">
                      <div class="has-feedback">
                        <input type="text" v-model="search" class="form-control input-sm"
                               :placeholder="$t('Search')">

                        <!-- <span
                            class="glyphicon glyphicon-search form-control-feedback"></span> -->
                      </div>
                    </div>
                    <!-- /.box-tools -->
                  </div>
                  <!-- /.box-header -->
                  <div class="box-body no-padding">

                    <div class="table-responsive mailbox-messages">
<!--                      <table class="table table-hover table-striped table-sm">-->
<!--                        <tbody>-->


<!--                        &lt;!&ndash;                                                    <tr id="items" v-for="(item, index) in filteredList"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            :key='index'&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                        :title="item.description">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            &lt;!&ndash; {{  | json }}&ndash;&gt;-->

<!--                        &lt;!&ndash;                                                                                                                                :checked="item.state = 1"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            &ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            <td>&ndash;&gt;-->

<!--                        &lt;!&ndash;                                                                <div>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    &lt;!&ndash;v-for="(item.order.services , index) in servies" :key="index"&ndash;&gt;-->

<!--                        &lt;!&ndash;                                                                      :disabled="end_time == '' "&ndash;&gt;-->

<!--                        &lt;!&ndash;                                                                     &ndash;&gt;&ndash;&gt;-->


<!--                        &lt;!&ndash;                                                                    <button  class="btn btn-info btn-xd" type="button"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                            v-on:click="addService(item.id, default_person, item.max_time ,$event, item.price, item.title, item.number, item, accounting_code_id)" >&ndash;&gt;-->
<!--                        &lt;!&ndash;انتخاب&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    </button>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    &lt;!&ndash;<input type="checkbox"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        &lt;!&ndash;class="option-input checkbox "&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        &lt;!&ndash;style="z-index: 0!important;"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        &lt;!&ndash;v-on:click="addService(item.id, default_person, item.max_time ,$event, item.price, item.title, item.number, item)" />&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    &ensp;&ensp;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    &lt;!&ndash; {{ order.servies.check }} &ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    {{ item.title }}&ndash;&gt;-->

<!--                        &lt;!&ndash;                                                                </div>&ndash;&gt;-->


<!--                        &lt;!&ndash;                                                            </td>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            <td class="mailbox-star"><a href="javascript: void(0)">&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                <i class="fa fa-star text-yellow"></i>&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            </a></td>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            <td class="mailbox-name">&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                <a v-if="item.service_category"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                    href="javascript: void(0)">{{  item.service_category.title }}&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                </a>&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            </td>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            <td class="mailbox-subject">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                <span :id="`showInput`+item.id" style="display:none">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    <input class="form-control" v-model="item.price"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        item.price type="number" data-type="number">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    <b @click="hideInput(item.id)">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        <i class="fa fa-times-circle-o" aria-hidden="true"></i>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    </b>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                </span>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                <span @click="inputEdit(item.id)">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    <b>{{ spliceNumber(item.price)  }} {{$curency}}  </b>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                </span>&ndash;&gt;-->


<!--                        &lt;!&ndash;                                                            </td>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            <td class="mailbox-date">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                <input class="form-control" v-model="item.number"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                       type="number" data-type="number" min="1" style="width: 70px">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            </td>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            <td class="mailbox-date">&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                {{ item.max_time }} {{ $t('min') }} &ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            </td>&ndash;&gt;-->

<!--                        &lt;!&ndash;                                                            <td class="mailbox-date">&ndash;&gt;-->


<!--                        &lt;!&ndash;                                                                <div class="dropdown">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    <button&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        class="btn btn-secondary btn-sm  dropdown-toggle"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        type="button" id="dropdownMenuButton"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        data-toggle="dropdown" aria-haspopup="true"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        aria-expanded="false"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        :disabled="end_time == '' || !order.services.find(x => x.service_id == item.id)">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        کارمند/پیمانکار&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    </button>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                    <div class="dropdown-menu"&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        style="text-align: center; "&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        aria-labelledby="dropdownMenuButton">&ndash;&gt;-->

<!--                        &lt;!&ndash;                                                                        <section>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                            <form>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                               &ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                                <ul class="nav ">&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                    <li class="nav-item" v-for="(person, index) in item.persons"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                     :key="index">&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        &ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        <div class="dropdown-item " v-on:click="setPerson(person.id, item.id)">&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                    &lt;!&ndash;&ndash;&gt;&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                    <div class="form-check text-right"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        style="margin: 7px">&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        <input type="radio"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        v-bind:name="person.id"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        v-model="person.id"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        value="person.id"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        class="option-input">&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        {{person.name}}&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                        {{person.family}}&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                    </div>&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                </div>&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;&lt;!&ndash;                                                                                    </li>&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                                    &ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                                </ul>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                                &ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                            </form>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                        </section>&ndash;&gt;-->


<!--                        &lt;!&ndash;                                                                    </div>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                                </div>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            </td>&ndash;&gt;-->


<!--                        &lt;!&ndash;                                                            &lt;!&ndash;<td><button type="button" class="btn btn-pur"&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            &lt;!&ndash;data-toggle="modal" data-target="#myModal"><i class="fa fa-user" aria-hidden="true"></i></button></td>&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                            &lt;!&ndash;<td class="mailbox-attachment"></td>&ndash;&gt;&ndash;&gt;-->

<!--                        &lt;!&ndash;                                                        </tr>&ndash;&gt;-->


<!--                        </tbody>-->


<!--                        <tbody-->
<!--                            v-for="(serviceCat,index) in filteredList">-->

<!--                        <tr v-if="serviceCat.services" data-toggle="collapse" :data-target="'#collapse-'+serviceCat.id"-->
<!--                            aria-expanded="false" :aria-controls="'#collapse-'+serviceCat.id"-->
<!--                            style="cursor: pointer">-->

<!--                          <td colspan="8">-->
<!--                            <b style="color: #2e5bbd"> {{ serviceCat.title }}</b>-->
<!--                          </td>-->


<!--                        </tr>-->

<!--                        <tr>-->
<!--                          <td colspan="6" class="collapse" :id="'collapse-'+serviceCat.id">-->
<!--                            <div class="card card-body mr-5 py-0 my-0 px-0">-->
<!--                              <table>-->
<!--                                <tbody>-->


<!--                                <tr :id="'service-by-cat-'+item.id" v-for="(item, index) in serviceCat.services"-->
<!--                                    :key='index'-->
<!--                                    :title="item.description">-->
<!--                                  &lt;!&ndash; {{  | json }}-->

<!--                                                                                                      :checked="item.state = 1"-->
<!--                                  &ndash;&gt;-->
<!--                                  <td>-->

<!--                                    <div>-->
<!--                                      &lt;!&ndash;v-for="(item.order.services , index) in servies" :key="index"-->

<!--                                        :disabled="end_time == '' "-->

<!--                                       &ndash;&gt;-->


<!--                                      <button class="btn btn-info btn-xd" type="button"-->
<!--                                              v-on:click="addService(item.id, default_person, item.max_time ,$event, item.price, item.title, item.number, item, accounting_code_id)">-->
<!--                                        <i class="fa fa-plus"></i>-->
<!--                                        انتخاب-->

<!--                                      </button>-->
<!--                                      &lt;!&ndash;<input type="checkbox"&ndash;&gt;-->
<!--                                      &lt;!&ndash;class="option-input checkbox "&ndash;&gt;-->
<!--                                      &lt;!&ndash;style="z-index: 0!important;"&ndash;&gt;-->
<!--                                      &lt;!&ndash;v-on:click="addService(item.id, default_person, item.max_time ,$event, item.price, item.title, item.number, item)" />&ndash;&gt;-->
<!--                                      &ensp;&ensp;-->
<!--                                      &lt;!&ndash; {{ order.servies.check }} &ndash;&gt;-->
<!--                                      {{ item.title }}-->

<!--                                    </div>-->


<!--                                  </td>-->
<!--                                  <td class="mailbox-star"><a href="javascript: void(0)">-->
<!--                                    &lt;!&ndash;                                                                <i class="fa fa-star text-yellow"></i>&ndash;&gt;-->
<!--                                  </a></td>-->
<!--                                  <td class="mailbox-name">-->
<!--                                    &lt;!&ndash;                                                                            <a v-if="item.service_category"&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                                                                                    href="javascript: void(0)">{{  item.service_category.title }}&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                                                        </a>&ndash;&gt;-->
<!--                                  </td>-->
<!--                                  <td class="mailbox-subject">-->
<!--                                                                <span v-if="$store.state.access"-->
<!--                                                                      :id="`showInput`+item.id" style="display:none">-->
<!--                                                                    <input class="form-control" v-model="item.price"-->
<!--                                                                           item.price type="number" data-type="number">-->
<!--                                                                    <b @click="hideInput(item.id)">-->
<!--                                                                        <i class="fa fa-times-circle-o"-->
<!--                                                                           aria-hidden="true"></i>-->
<!--                                                                    </b>-->
<!--                                                                </span>-->
<!--                                    <span @click="inputEdit(item.id)">-->
<!--                                                                    <b v-if="$store.state.access">{{-->
<!--                                                                        spliceNumber(item.price)-->
<!--                                                                      }} {{ $curency }}  </b>-->
<!--                                                                </span>-->


<!--                                  </td>-->
<!--                                  <td class="mailbox-date">-->
<!--                                    <input class="form-control" v-model="item.number"-->
<!--                                           type="number" data-type="number" min="1" style="width: 70px">-->
<!--                                  </td>-->
<!--                                  <td class="mailbox-date">-->
<!--                                    &lt;!&ndash;                                                                {{ item.max_time }} {{ $t('min') }} &ndash;&gt;-->
<!--                                  </td>-->

<!--                                  <td class="mailbox-date">-->


<!--                                    <div class="dropdown">-->
<!--                                      <button-->
<!--                                          class="btn btn-secondary btn-sm  dropdown-toggle"-->
<!--                                          type="button" id="dropdownMenuButton"-->
<!--                                          data-toggle="dropdown" aria-haspopup="true"-->
<!--                                          aria-expanded="false"-->
<!--                                          :disabled="end_time == '' || !order.services.find(x => x.service_id == item.id)">-->
<!--                                        کارمند/پیمانکار-->
<!--                                      </button>-->
<!--                                      <div class="dropdown-menu"-->
<!--                                           style="text-align: center; "-->
<!--                                           aria-labelledby="dropdownMenuButton">-->

<!--                                        <section>-->
<!--                                          <form>-->

<!--                                            <ul class="nav " v-if="item.persons">-->
<!--                                              &lt;!&ndash;                                                                                                <li class="nav-item" v-for="(person, index) in item.persons"&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                    :key="index">&ndash;&gt;-->

<!--                                              &lt;!&ndash;                                                                                                    <div class="dropdown-item " v-on:click="setPerson(person.id, item.id)">&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                        &lt;!&ndash;&ndash;&gt;&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                        <div class="form-check text-right"&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                             style="margin: 7px">&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                            <input type="radio"&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                                   v-bind:name="person.id"&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                                   v-model="person.id"&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                                   value="person.id"&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                                   class="option-input">&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                            {{person.name}}&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                            {{person.family}}&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                        </div>&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                    </div>&ndash;&gt;-->
<!--                                              &lt;!&ndash;                                                                                                </li>&ndash;&gt;-->

<!--                                            </ul>-->

<!--                                          </form>-->
<!--                                        </section>-->


<!--                                      </div>-->
<!--                                    </div>-->
<!--                                  </td>-->


<!--                                  &lt;!&ndash;<td><button type="button" class="btn btn-pur"&ndash;&gt;-->
<!--                                  &lt;!&ndash;data-toggle="modal" data-target="#myModal"><i class="fa fa-user" aria-hidden="true"></i></button></td>&ndash;&gt;-->
<!--                                  &lt;!&ndash;<td class="mailbox-attachment"></td>&ndash;&gt;-->

<!--                                </tr>-->


<!--                                </tbody>-->
<!--                              </table>-->
<!--                            </div>-->
<!--                          </td>-->

<!--                        </tr>-->


<!--                        </tbody>-->


<!--                      </table>-->


                      <!-- /.table -->
                    </div>
                    <!-- /.mail-box-messages -->
                    <!-- Modal -->
                    <div id="myModal" class="modal fade" role="dialog">
                      <div class="modal-dialog">

                        <!-- Modal content-->
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close"
                                    data-dismiss="modal">&times;
                            </button>
                            <h4 class="modal-title">{{ $t('s') }}</h4>

                          </div>
                          <div class="modal-body">
                            <div class="box">
                              <div class="box-header with-border"
                                   style="background-color: #00acc1;color: #fff">
                                <h3 class="box-title"> {{ $t('s') }} </h3>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body"
                                   style="max-height: 220px;overflow-y: scroll;">
                                <table class="table table-bordered table-sm">
                                  <tr>
                                    <th style="width: 10px"></th>
                                    <th>{{ $t('image') }}</th>
                                    <th></th>

                                    <th style="width: 40px">{{ $t('Services') }}</th>
                                  </tr>


                                  <tr id="persons"
                                      v-for="(person, index) in persons"
                                      :key="index">
                                    <td>
                                      <label>
                                        <div class="form-group2">
                                          <input type="checkbox"
                                                 id="html1" class="label2">
                                          <label for="html1"></label>
                                        </div>
                                      </label>
                                    </td>


                                    <td>
                                      <div class="center-block text-center">
                                        <img style="width: 40px ; "
                                             src="dist/img/user3-128x128.jpg"
                                             class="img-circle"
                                             alt="User Image">
                                      </div>
                                    </td>


                                    <td>
                                                                                <span v-if="person">
                                                                                    {{ person.name }}
                                                                                </span>


                                    </td>


                                  </tr>


                                </table>
                              </div>
                              <!-- /.box-body -->
                              <div class="box-footer clearfix">
                                <ul
                                    class="pagination pagination-sm no-margin pull-right">
                                  <li><a href="javascript: void(0)">&raquo;</a>
                                  </li>
                                  <li><a href="javascript: void(0)">1</a></li>

                                  <li><a href="javascript: void(0)"> &laquo;</a>
                                  </li>
                                </ul>
                              </div>


                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-default"
                                    data-dismiss="modal"> {{ $t('Close') }}
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                  <!-- /.box-body -->
                  <div class="box-footer no-padding">
                    <div class="mailbox-controls">
                      <!-- Check all button -->
                      <!--<pagination api="/api/services" @pagnationChangeDate='pagnation'>-->
                      <!--</pagination>-->


                      <!-- <div class="pull-left">
                          1/1
                          <div class="btn-group">
                              <button type="button" class="btn btn-default btn-sm"><i
                                      class="fa  fa-chevron-left"></i></button>
                              <button type="button" class="btn btn-default btn-sm"><i
                                      class="fa fa-chevron-right"></i></button>
                          </div>

                      </div> -->
                      <!-- /.pull-right -->
                    </div>
                  </div>


                </div>
                <!-- /.tab-pane -->
                <div class="tab-pane active" id="tab_2">
                  <div class="box-header with-border">
                    <span class="box-title">لیست کالا: </span>

                    <div class="box-tools pull-right">
                      <div class="has-feedback">
                        <input type="text" class="form-control input-sm"
                               v-model="searchProduct" :placeholder="$t('Search')">
                        <!--
                                                                            <span
                                                                                class="glyphicon glyphicon-search form-control-feedback"></span> -->
                      </div>
                    </div>
                    <!-- /.box-tools -->
                  </div>
                  <!-- /.box-header -->
                  <div class="box-body no-padding" style="background-color: white">
                    <div class="table-responsive mailbox-messages">
                      <table class="table table-hover table-striped ">
                        <tbody>


                        <!--                                                    <tr id="product-items"-->
                        <!--                                                        v-for="(product,index) in filteredListProuduct"-->
                        <!--                                                        :key="index"-->
                        <!--                                                        :title="product.description">-->
                        <!--                                                        <td>-->
                        <!--                                                            <div>-->

                        <!--                                                                <button  class="btn btn-info btn-xd" type="button"-->
                        <!--                                                                         v-on:click="addProduct(product.id, product.unit, product.price ,$event, product.title , product.number, product, accounting_code_id)" >-->
                        <!--                                                                    انتخاب-->
                        <!--                                                                </button>-->
                        <!--                                                                &lt;!&ndash;<input type="checkbox"&ndash;&gt;-->
                        <!--                                                                &lt;!&ndash;class="option-input checkbox "&ndash;&gt;-->
                        <!--                                                                &lt;!&ndash;style="z-index: 0!important;"&ndash;&gt;-->
                        <!--                                                                &lt;!&ndash;@click="addProduct(product.id, product.unit, product.price ,$event, product.title , product.number, product)" />&ndash;&gt;-->
                        <!--                                                                &ensp;&ensp;-->

                        <!--                                                                {{ product.title }}-->

                        <!--                                                            </div>-->
                        <!--                                                        </td>-->
                        <!--                                                        <td class="mailbox-star"><a href="javascript: void(0)">-->
                        <!--                                                            &lt;!&ndash;                                                                <i class="fa fa-star text-yellow"></i>&ndash;&gt;-->
                        <!--                                                        </a></td>-->
                        <!--                                                        <td class="mailbox-name text-center"><a href="javascript: void(0)">-->

                        <!--                                                            <img :src="`/`+product.image" alt="" style="width: 25px;">-->
                        <!--                                                            &lt;!&ndash; {{ product.product_category.title }} &ndash;&gt;-->

                        <!--                                                        </a></td>-->

                        <!--                                                        <td class="mailbox-name"><a v-if="product.product_category  !==null"-->
                        <!--                                                                                    href="javascript: void(0)">{{  product.product_category.title }}-->

                        <!--                                                            <b v-if="product.product_category.parent"> ({{product.product_category.parent.title}}) </b>-->
                        <!--                                                        </a></td>-->


                        <!--                                                        <td class="mailbox-subject">-->

                        <!--                                                                <span :id="`showInput`+product.id" style="display:none">-->
                        <!--                                                                    <input class="form-control" v-model="product.price"-->
                        <!--                                                                           type="text" data-type="number">-->
                        <!--                                                                    <b @click="hideInput(product.id)"> <i class="fa fa-times" aria-hidden="true"></i></b>-->
                        <!--                                                                </span>-->
                        <!--                                                            <span @click="inputEdit(product.id)">-->
                        <!--                                                                    <b>{{ spliceNumber(product.price)  }} {{$curency}}  </b>-->
                        <!--                                                                </span>-->

                        <!--                                                        </td>-->
                        <!--                                                        <td class="mailbox-date">-->
                        <!--                                                            <input class="form-control" v-model="product.number"-->
                        <!--                                                                   type="number" data-type="number" min="1" style="width: 70px">-->
                        <!--                                                        </td>-->

                        <!--                                                        <td class="mailbox-date">-->
                        <!--                                                            <span v-text="filteritemType(product.unit)"></span>-->
                        <!--                                                        </td>-->
                        <!--                                                        &lt;!&ndash;                                                            <td class="mailbox-date">&ndash;&gt;-->
                        <!--                                                        &lt;!&ndash;                                                                {{ product.description }}&ndash;&gt;-->
                        <!--                                                        &lt;!&ndash;                                                            </td>&ndash;&gt;-->
                        <!--                                                        &lt;!&ndash; <td class="mailbox-date">-->
                        <!--                                                            <input type="text" v-model="order.products.amount">-->

                        <!--                                                        </td> &ndash;&gt;-->
                        <!--                                                    </tr>-->


                        </tbody>
                      </table>
                      <!-- /.table -->




<!--                      <table class="table table-hover table-striped  table-sm" id="product-cat-items"-->
<!--                             v-if="productCat.childes || productCat.products"-->
<!--                             v-for="(productCat,index) in filteredListProuduct"-->
<!--                             :key="index"-->
<!--                             :title="productCat.title">-->


<!--                        <tbody v-if="productCat.childes && child.products"-->
<!--                               v-for="(child,index) in productCat.childes">-->

<!--                        <tr v-if="child.products.length" data-toggle="collapse" :data-target="'#collapse-'+child.id"-->
<!--                            aria-expanded="false" :aria-controls="'#collapse-'+child.id"-->
<!--                            style="cursor: pointer">-->

<!--                          <td colspan="6"> {{ productCat.title }}-->
<!--                            <i class="fas fa-arrow-left"></i>-->
<!--                            <b style="color: #2e5bbd"> {{ child.title }} </b>-->
<!--                          </td>-->


<!--                        </tr>-->

<!--                        <tr>-->
<!--                          <td colspan="6" class="collapse" :id="'collapse-'+child.id">-->
<!--                            <div class="card card-body mr-5 py-0 my-0 px-0">-->
<!--                              <table>-->
<!--                                <tbody>-->
<!--                                <tr :id="'product-by-cat-'+product.id"-->
<!--                                    v-for="(product,index) in child.products"-->
<!--                                    :key="index"-->
<!--                                    :title="product.description">-->
<!--                                  <td>-->
<!--                                    <div>-->

<!--                                      <button class="btn btn-info btn-xd" type="button"-->
<!--                                              v-on:click="addProduct(product.id, product.unit, product.price ,$event, product.title , product.number, product, accounting_code_id)">-->
<!--                                        <i class="fa fa-plus"></i>-->
<!--                                        انتخاب-->
<!--                                      </button>-->
<!--                                      &lt;!&ndash;<input type="checkbox"&ndash;&gt;-->
<!--                                      &lt;!&ndash;class="option-input checkbox "&ndash;&gt;-->
<!--                                      &lt;!&ndash;style="z-index: 0!important;"&ndash;&gt;-->
<!--                                      &lt;!&ndash;@click="addProduct(product.id, product.unit, product.price ,$event, product.title , product.number, product)" />&ndash;&gt;-->
<!--                                      &ensp;&ensp;-->

<!--                                      {{ product.title }}-->

<!--                                      <span v-if="product.max_time"> - <i-->
<!--                                          class="fas fa-calendar"></i> {{ product.max_time }}-->
<!--                                                                                    <small-->
<!--                                                                                        v-if="product.reference">({{ product.reference }})</small>-->
<!--                                                                                  </span>-->

<!--                                    </div>-->
<!--                                  </td>-->
<!--                                  <td><a href="javascript: void(0)">-->
<!--                                    &lt;!&ndash;                                                                <i class="fa fa-star text-yellow"></i>&ndash;&gt;-->
<!--                                  </a></td>-->
<!--                                  <td class="text-center"><a href="javascript: void(0)">-->

<!--                                    <img :src="`/`+product.image" alt="" style="width: 25px;">-->
<!--                                    &lt;!&ndash; {{ product.product_category.title }} &ndash;&gt;-->

<!--                                  </a></td>-->

<!--                                  &lt;!&ndash;                                                            <td class="mailbox-name"><a v-if="product.product_category  !==null"&ndash;&gt;-->
<!--                                  &lt;!&ndash;                                                                                        href="javascript: void(0)">{{  product.product_category.title }}&ndash;&gt;-->

<!--                                  &lt;!&ndash;                                                                <b v-if="product.product_category.parent"> ({{product.product_category.parent.title}}) </b>&ndash;&gt;-->
<!--                                  &lt;!&ndash;                                                            </a></td>&ndash;&gt;-->


<!--                                  <td>-->

<!--                                                                <span v-if="$store.state.access"-->
<!--                                                                      :id="`showInput`+product.id" style="display:none">-->
<!--                                                                    <input class="form-control" v-model="product.price"-->
<!--                                                                           type="text" data-type="number">-->
<!--                                                                    <b @click="hideInput(product.id)"> <i-->
<!--                                                                        class="fa fa-times" aria-hidden="true"></i></b>-->
<!--                                                                </span>-->
<!--                                    <span @click="inputEdit(product.id)">-->
<!--                                                                    <b v-if="$store.state.access">{{-->
<!--                                                                        spliceNumber(product.price)-->
<!--                                                                      }} {{ $curency }}  </b>-->
<!--                                                                </span>-->

<!--                                  </td>-->
<!--                                  <td class="">-->
<!--                                    <input class="form-control" v-model="product.number"-->
<!--                                           type="number" data-type="number" min="1" style="width: 70px">-->
<!--                                  </td>-->

<!--                                  <td class="">-->
<!--                                    <span v-text="filteritemType(product.unit)"></span>-->
<!--                                  </td>-->
<!--                                  &lt;!&ndash;                                                            <td class="mailbox-date">&ndash;&gt;-->
<!--                                  &lt;!&ndash;                                                                {{ product.description }}&ndash;&gt;-->
<!--                                  &lt;!&ndash;                                                            </td>&ndash;&gt;-->
<!--                                  &lt;!&ndash; <td class="mailbox-date">-->
<!--                                      <input type="text" v-model="order.products.amount">-->

<!--                                  </td> &ndash;&gt;-->
<!--                                </tr>-->
<!--                                </tbody>-->
<!--                              </table>-->
<!--                            </div>-->
<!--                          </td>-->

<!--                        </tr>-->


<!--                        </tbody>-->


<!--                        <tbody v-if="productCat.products.length > 0">-->

<!--                        <tr data-toggle="collapse" :data-target="'#collapse-subProductCat-'+productCat.id"-->
<!--                            aria-expanded="false" :aria-controls="'#collapse-subProductCat-'+productCat.id"-->
<!--                            style="cursor: pointer">-->

<!--                          <td colspan="6">-->
<!--                            <b style="color: #2e5bbd"> {{ productCat.title }} </b>-->
<!--                          </td>-->


<!--                        </tr>-->

<!--                        <tr>-->
<!--                          <td colspan="6" class="collapse" :id="'collapse-subProductCat-'+productCat.id">-->
<!--                            <div class="card card-body mr-5 py-0 my-0 px-0">-->
<!--                              <table>-->
<!--                                <tbody>-->
<!--                                <tr :id="'product-by-cat-'+product.id"-->
<!--                                    v-for="(product,index) in productCat.products"-->
<!--                                    :key="index"-->
<!--                                    :title="product.description">-->
<!--                                  <td>-->
<!--                                    <div>-->

<!--                                      <button class="btn btn-info btn-xd" type="button"-->
<!--                                              v-on:click="addProduct(product.id, product.unit, product.price ,$event, product.title , product.number, product, accounting_code_id)">-->
<!--                                        <i class="fa fa-plus"></i>-->
<!--                                        انتخاب-->
<!--                                      </button>-->
<!--                                      &lt;!&ndash;<input type="checkbox"&ndash;&gt;-->
<!--                                      &lt;!&ndash;class="option-input checkbox "&ndash;&gt;-->
<!--                                      &lt;!&ndash;style="z-index: 0!important;"&ndash;&gt;-->
<!--                                      &lt;!&ndash;@click="addProduct(product.id, product.unit, product.price ,$event, product.title , product.number, product)" />&ndash;&gt;-->
<!--                                      &ensp;&ensp;-->

<!--                                      {{ product.title }}-->

<!--                                      <span v-if="product.max_time"> - <i-->
<!--                                          class="fas fa-calendar"></i> {{ product.max_time }}-->
<!--                                                                                    <small-->
<!--                                                                                        v-if="product.reference">({{ product.reference }})</small>-->
<!--                                                                                  </span>-->

<!--                                    </div>-->
<!--                                  </td>-->
<!--                                  <td><a href="javascript: void(0)">-->
<!--                                    &lt;!&ndash;                                                                <i class="fa fa-star text-yellow"></i>&ndash;&gt;-->
<!--                                  </a></td>-->
<!--                                  <td class="text-center"><a href="javascript: void(0)">-->

<!--                                    <img :src="`/`+product.image" alt="" style="width: 25px;">-->
<!--                                    &lt;!&ndash; {{ product.product_category.title }} &ndash;&gt;-->

<!--                                  </a></td>-->

<!--                                  &lt;!&ndash;                                                            <td class="mailbox-name"><a v-if="product.product_category  !==null"&ndash;&gt;-->
<!--                                  &lt;!&ndash;                                                                                        href="javascript: void(0)">{{  product.product_category.title }}&ndash;&gt;-->

<!--                                  &lt;!&ndash;                                                                <b v-if="product.product_category.parent"> ({{product.product_category.parent.title}}) </b>&ndash;&gt;-->
<!--                                  &lt;!&ndash;                                                            </a></td>&ndash;&gt;-->


<!--                                  <td>-->

<!--                                                                <span v-if="$store.state.access"-->
<!--                                                                      :id="`showInput`+product.id" style="display:none">-->
<!--                                                                    <input class="form-control" v-model="product.price"-->
<!--                                                                           type="text" data-type="number">-->
<!--                                                                    <b @click="hideInput(product.id)"> <i-->
<!--                                                                        class="fa fa-times" aria-hidden="true"></i></b>-->
<!--                                                                </span>-->
<!--                                    <span @click="inputEdit(product.id)">-->
<!--                                                                    <b v-if="$store.state.access">{{-->
<!--                                                                        spliceNumber(product.price)-->
<!--                                                                      }} {{ $curency }}  </b>-->
<!--                                                                </span>-->

<!--                                  </td>-->
<!--                                  <td class="">-->
<!--                                    <input class="form-control" v-model="product.number"-->
<!--                                           type="number" data-type="number" min="1" style="width: 70px">-->
<!--                                  </td>-->

<!--                                  <td class="">-->
<!--                                    <span v-text="filteritemType(product.unit)"></span>-->
<!--                                  </td>-->
<!--                                  &lt;!&ndash;                                                            <td class="mailbox-date">&ndash;&gt;-->
<!--                                  &lt;!&ndash;                                                                {{ product.description }}&ndash;&gt;-->
<!--                                  &lt;!&ndash;                                                            </td>&ndash;&gt;-->
<!--                                  &lt;!&ndash; <td class="mailbox-date">-->
<!--                                      <input type="text" v-model="order.products.amount">-->

<!--                                  </td> &ndash;&gt;-->
<!--                                </tr>-->
<!--                                </tbody>-->
<!--                              </table>-->
<!--                            </div>-->
<!--                          </td>-->

<!--                        </tr>-->


<!--                        </tbody>-->


<!--                      </table>-->


                    </div>
                    <!-- /.mail-box-messages -->
                  </div>
                  <!-- /.box-body -->
                  <div class="box-footer no-padding">
                    <div class="mailbox-controls">
                    </div>
                  </div>
                </div>

                <div class="tab-pane" id="tab_3">
                  <!--                                        <div class="box-header with-border">-->
                  <!--                                            <h3 class="box-title"></h3>-->

                  <!--                                            <div class="box-tools pull-right">-->
                  <!--                                                <div class="has-feedback">-->
                  <!--                                                    <input type="text" class="form-control input-sm"-->
                  <!--                                                           v-model="searchProduct" :placeholder="$t('Search')">-->
                  <!--                                                    &lt;!&ndash;-->
                  <!--                                                                                                        <span-->
                  <!--                                                                                                            class="glyphicon glyphicon-search form-control-feedback"></span> &ndash;&gt;-->
                  <!--                                                </div>-->
                  <!--                                            </div>-->
                  <!--                                            &lt;!&ndash; /.box-tools &ndash;&gt;-->
                  <!--                                        </div>-->
                  <!-- /.box-header -->
                  <div class="box-body no-padding" style="background-color: white">
                    <div class="table-responsive mailbox-messages">
                      <table class="table table-hover table-striped table-sm">
                        <tbody>


                        <!--                                                    <tr id="orderProducts1" v-for="(item, orderProductIndex) in order.products"-->
                        <!--                                                        :title="item.note" style="background-color: #3a7fd4;color: white">-->
                        <!--                                                        &lt;!&ndash; {{  | json }}-->

                        <!--                                                                                                                            :checked="item.state = 1"-->
                        <!--                                                        &ndash;&gt;-->
                        <!--                                                        <td>-->

                        <!--                                                            <button  class="btn btn-dark btn-sm" type="button"-->
                        <!--                                                                     v-on:click="removeProduct(item.item)" >-->
                        <!--                                                                حذف-->
                        <!--                                                            </button>-->


                        <!--                                                        </td>-->

                        <!--                                                        <td  title="کد حسابداری" colspan="2" class="">-->

                        <!--                                                            &lt;!&ndash;                                                            <label class="control-label"></label>&ndash;&gt;-->
                        <!--                                                            <v-select-->
                        <!--                                                                    v-model="item.accounting_code_id" class="form-control-sm mt-0 pt-0"-->
                        <!--                                                                    :options="accountingCodes" label="title" :reduce="accountingCode => accountingCode.id" value="id">-->
                        <!--                                                            </v-select>-->


                        <!--                                                            &lt;!&ndash;                                                            <b-form-select v-model="item.accounting_code_id" >&ndash;&gt;-->
                        <!--                                                            &lt;!&ndash;                                                                <b-form-select-option v-for="(accountingCode, accountingCodeIndex) in accountingCodes" :key="accountingCodeIndex" :value="accountingCode.id">&ndash;&gt;-->
                        <!--                                                            &lt;!&ndash;                                                                    {{accountingCode.code+'-'+accountingCode.title}}&ndash;&gt;-->
                        <!--                                                            &lt;!&ndash;                                                                </b-form-select-option>&ndash;&gt;-->

                        <!--                                                            &lt;!&ndash;                                                            </b-form-select>&ndash;&gt;-->

                        <!--                                                        </td>-->


                        <!--                                                        <td title="عنوان/شرح">-->
                        <!--                                                            <input class="form-control form-control-sm" v-model="item.note"-->
                        <!--                                                                   type="text" data-type="text">-->
                        <!--                                                        </td>-->

                        <!--                                                        <td  title="واحد">-->

                        <!--                                                            <select class="form-control form-control-sm" v-model="item.unit">-->
                        <!--                                                                <option value="0"> {{ $t('Number') }}</option>-->
                        <!--                                                                <option value="1">{{ $t('g') }}</option>-->
                        <!--                                                                <option value="2">{{ $t('Kg') }}</option>-->
                        <!--                                                                <option value="3">{{ $t('Liter') }}</option>-->
                        <!--                                                                <option value="4">{{ $t('packet') }}</option>-->

                        <!--                                                            </select>-->
                        <!--                                                        </td>-->

                        <!--                                                        <td  title="مقدار/تعداد">-->

                        <!--                                                            <input class="form-control form-control-sm" v-model="item.amount"-->
                        <!--                                                                   type="number" data-type="number">-->
                        <!--                                                        </td>-->


                        <!--                                                        <td title="قیمت واحد">-->
                        <!--                                                            <input class="form-control form-control-sm" v-model="item.price"-->
                        <!--                                                                   type="number" data-type="number">-->
                        <!--                                                        </td>-->


                        <!--                                                        <td colspan="2" class="mailbox-subject">-->
                        <!--                                                                <span :id="`showInput`+item.id" style="display:none">-->
                        <!--                                                                    <input disabled class="form-control  form-control-sm" v-model="item.price*item.amount"-->
                        <!--                                                                           item.price type="number" data-type="number">-->
                        <!--                                                                    <b @click="hideInput(item.id)">-->
                        <!--                                                                        <i class="fa fa-times" aria-hidden="true"></i>-->
                        <!--                                                                    </b>-->
                        <!--                                                                </span>-->
                        <!--                                                            <span @click="inputEdit(item.id)">-->
                        <!--                                                                    <b>{{ spliceNumber(item.price*item.amount)  }} {{$curency}}  </b>-->

                        <!--                                                            </span>-->


                        <!--                                                        </td>-->
                        <!--                                                        &lt;!&ndash;<td class="mailbox-date">&ndash;&gt;-->
                        <!--                                                        &lt;!&ndash;<input class="form-control" v-model="item.number"&ndash;&gt;-->
                        <!--                                                        &lt;!&ndash;type="number" data-type="number" min="1" style="width: 70px">&ndash;&gt;-->
                        <!--                                                        &lt;!&ndash;</td>&ndash;&gt;-->

                        <!--                                                    </tr>-->


                        <tr :id="'vendor-product-items-'+product.id"
                            v-for="(product,index) in products"
                            :key="index"
                            :title="product.description">
                          <td>
                            <div>

                              <button class="btn btn-info btn-xd" type="button"
                                      v-on:click="addProduct(product.id, product.unit, product.price ,$event, product.title , product.number, product, accounting_code_id)">
                                انتخاب
                              </button>
                              <!--<input type="checkbox"-->
                              <!--class="option-input checkbox "-->
                              <!--style="z-index: 0!important;"-->
                              <!--@click="addProduct(product.id, product.unit, product.price ,$event, product.title , product.number, product)" />-->
                              &ensp;&ensp;

                              {{ product.title }}

                            </div>
                          </td>
                          <td class="mailbox-star"><a href="javascript: void(0)">
                            <!--                                                                <i class="fa fa-star text-yellow"></i>-->
                          </a></td>
                          <td class="mailbox-name text-center"><a href="javascript: void(0)">

                            <img :src="`/`+product.image" alt="" style="width: 25px;">
                            <!-- {{ product.product_category.title }} -->

                          </a></td>

                          <td class="mailbox-name"><a v-if="product.product_category  !==null"
                                                      href="javascript: void(0)">{{ product.product_category.title }}

                            <b v-if="product.product_category.parent">
                              ({{ product.product_category.parent.title }}) </b>
                          </a></td>


                          <td colspan="2" class="mailbox-subject">

                                                                <span v-if="$store.state.access"
                                                                      :id="`showInput`+product.id" style="display:none">
                                                                    <input class="form-control" v-model="product.price"
                                                                           type="text" data-type="number">
                                                                    <b @click="hideInput(product.id)"> <i
                                                                        class="fa fa-times" aria-hidden="true"></i></b>
                                                                </span>
                            <span @click="inputEdit(product.id)">
                                                                    <b v-if="$store.state.access">{{
                                                                        spliceNumber(product.price)
                                                                      }} {{ $curency }}  </b>
                                                                </span>

                          </td>
                          <td class="mailbox-date">
                            <input class="form-control" v-model="product.number"
                                   type="number" data-type="number" min="1" style="width: 70px">
                          </td>

                          <td class="mailbox-date">
                            <span v-text="filteritemType(product.unit)"></span>
                          </td>
                          <!--                                                            <td class="mailbox-date">-->
                          <!--                                                                {{ product.description }}-->
                          <!--                                                            </td>-->
                          <!-- <td class="mailbox-date">
                              <input type="text" v-model="order.products.amount">

                          </td> -->
                        </tr>


                        </tbody>
                      </table>
                      <!-- /.table -->


                    </div>
                    <!-- /.mail-box-messages -->
                  </div>
                  <!-- /.box-body -->
                  <div class="box-footer no-padding">
                    <div class="mailbox-controls">
                    </div>
                  </div>
                </div>


              </div>
              <!-- /.tab-content -->
            </div>


          </div>
          <!-- /. box -->
        </div>


      </div>


    </section>


  </div>

</template>


<script>
// import scheduler from '../dashboard/Scheduler'
const auth = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token')
  }
};


export default {
  components: {
    // scheduler
  },
  data() {
    return {
      auth: {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token')
        }
      },

      user_id: null,

      colors: ['#00acc1'],
      activeColorIndex: 0,

      projects: [],
      contacts: [],
      units: [],

      persons: [],
      order: {
        products: [

        ],
        services: [
            // {
            //     check:[],
            //     service_id: '',
            //     person_id: '',
            //     note: ''
            // }
        ],

        date: '1398/09/08',
        start_at: '09:00',
        end_at: '',
        user_id: this.user_id,
        description: '',

        contact_id: null,
        project_id: null,
        accounting_code_id: null,
        product_serial: null,
        product_reference: null,

        order_type: '',
        factor_type: 0,
        factor_state: 2,
        payment_state: '',

        code: null,
        factorDate: null,
        companyId: this.$companyId,
        buyer: {
          buyerId:null,
          note:null,
          nationalCode:null,
          buyerType:null,
          postCode:null,
        },
        payType: null,
        payed: 0,
        state: "type1",
        note: null,
        items: [],
        pattern: "pattern1",
        contractId: null,

      },


      errors: [],
      end_time: '',
      default_person: '',
      valObj: [],
      mintimeMoment: '',
      dateNow: '',

      allProducts: [],
      allServices: [],
      products: [],
      productsListByCategory: [],
      servicesListByCategory: [],

      factorItems: [],
      factorItem: {
        product: {
          code:null,
          name:null,
          unit:{
            code:null,
            name:null
          }
        },
        amount:null,
        price:null,
        discount:null,
        tax:null,
        otherCharges:null,
        detail:null,
      },
      items: [],
      showInput: false,
      loader: false,
      search: "",
      searchProduct: "",
      contactInfo: [],

      accounting_code_id: null,

      vendorProducts: [],

    }
  }

  ,
  computed: {
    // filteredList() {
    //
    //
    //   if (this.servicesListByCategory.length > 0 && this.search) {
    //     var services = this.servicesListByCategory.filter(items => {
    //       return items.title.toLowerCase().includes(this.search.toLowerCase())
    //     })
    //     return services
    //   } else {
    //     // return []
    //     return this.servicesListByCategory
    //   }
    //
    // },
    // filteredListProuduct() {
    //
    //   if (this.productsListByCategory.length > 0 && this.searchProduct) {
    //     var products = this.productsListByCategory.filter(items => {
    //       return items.title.toLowerCase().includes(this.searchProduct.toLowerCase())
    //     })
    //
    //     for (let value of this.productsListByCategory) {
    //       if (value.childes.length > 0)
    //         var subProducts = value.childes.filter(items => {
    //           return items.title.toLowerCase().includes(this.searchProduct.toLowerCase())
    //         })
    //
    //       if (subProducts.length)
    //         products = subProducts
    //       // products.concat(subProducts)
    //     }
    //
    //     return products
    //
    //   } else {
    //     return this.productsListByCategory
    //   }
    //
    // },


  },


  watch: {


    // order: {
    //     deep: true,
    //     handler() {
    //
    //         if (this.contacts.find(x => x.user_id == this.order.user_id))
    //             this.getVendorProducts(this.contacts.find(x => x.user_id == this.order.user_id).id)
    //
    //     }
    // }

  },

  mounted() {

    this.addProductEmpty()
    // this.$store.state.roles = this.pluck(JSON.parse(localStorage.getItem('roles')), 'name')
    // this.$store.state.accesses = ['superadministrator', 'admin']
    // this.$store.commit('intersection')
    // this.$store.commit('checkIntersection')
    //
    // if (this.$route.params.id) {
    //   this.user_id = this.$route.params.id
    //   this.order.user_id = this.$route.params.id
    // }

    //            this.date = document.getElementById("mintime").innerHTML
    // this.order.factorDate = document.getElementById("mintime").innerHTML


    // axios
    //     .get('/api/productsListByCategory', this.auth)
    //     .then(response => {
    //       console.log('productsListByCategory', response.data.data);
    //
    //       this.productsListByCategory = response.data.data
    //
    //       // this.productsListByCategory.products.forEach(function (element) {
    //       //     element.number = "1";
    //       // });
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.errored = true
    //     })


    // axios
    //     .get(`/api/user/${this.user_id}`, this.auth)
    //     .then(response => {
    //       this.contactInfo = response.data.data;
    //
    //       console.log(this.contactInfo, "contactInfo");
    //
    //
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.errored = true
    //
    //     })
    //     .finally(() => {
    //       this.getAllProducts()
    //     })
    //
    //
    // this.getServicesByCategory();
    // this.getAvailableServices();


    // axios
    //     .get('/api/persons', this.auth)
    //     .then(response => {
    //         this.persons = response.data.data;
    //         //                    console.log(this.items);
    //
    //     })
    //     .catch(error => {
    //         console.log(error);
    //         this.errored = true
    //     })
    //     .finally(() => this.loading = false)


    // this.getUnits();
    // this.getProjects();
    // this.getAccountingCodes();
    //
    // // if (!this.$route.params.id)
    // this.getContacts();
    //
    this.momentjalaliVue()


  },

  methods: {


    // filteredList() {

    //     return this.items.filter(post => {
    //         return post.title.toLowerCase().includes(this.search.toLowerCase())
    //     })
    // },
    // filteredListProuduct() {

    //     return this.products.filter(post => {
    //         return post.title.toLowerCase().includes(this.searchProduct.toLowerCase())
    //     })
    // },


    updateVendorData() {

      console.log('updateVendorData')
      // console.log($event.target.value)


      if (this.contacts.find(x => x.user_id == this.order.user_id))
        this.getVendorProducts(this.contacts.find(x => x.user_id == this.order.user_id).id)
      // if (this.contacts.find(x => x.user_id == $event.target.value))
      //     this.getVendorProducts(this.contacts.find(x => x.user_id == $event.target.value).id)

    },


    getAllProducts() {
      axios
          .get('/api/productslist', this.auth)
          .then(response => {

            this.allProducts = response.data.data;
            // this.allProducts = response.data.data;
            // this.allProducts = this.products;

            // this.products.forEach(function (element) {
            //     element.number = "1";
            // });
            this.getVendorProducts(this.contactInfo.contact.id)

          })
          .catch(error => {
            console.log(error);
            this.errored = true
          })

    },


    parentSetData() {
      // var app = this;
      //
      // // app.getAvailableServices();
      //
      // axios
      //     .get('/api/workCalendar/?' + 'date_from=' + this.order.date, app.auth)
      //     .then(response => {
      //         app.timingItems = response.data;
      //         console.log(response.data);
      //         console.log(this.order.date);
      //
      //         this.$refs.foo.changeSetData(response.data)
      //         app.$snotify.success(app.$t('Information updated successfully'));
      //
      //
      //     })
      //     .catch(error => {
      //         console.log(error);
      //         app.$snotify.warning(app.$t('Unable to update information'));
      //
      //         app.errored = true
      //     })
      //     .finally(() => app.loading = false);

    },

    getAvailableServices() {

      this.order.services = []

      // $event.target.checked  = !isAllCheck


      axios
          .get('/api/order/getAvailableServices?date=' + this.order.date, this.auth)
          .then(response => {
            //   var result = Object.keys(response.data.data).map(function (key) {
            //    return response.data.data[key];
            //   });
            //
            //  this.items = result;
            //
            // this.items.forEach(function (element) {
            //     element.number = "1";
            // });
            this.items = response.data.data;
            this.allServices = this.items;


          })
          .catch(error => {
            console.log(error);
            this.errored = true
          })
          .finally(() => this.loading = false);


    },


    getServicesByCategory() {
      axios
          .get('/api/servicesListByCategory', this.auth)
          .then(response => {
            console.log('servicesListByCategory', response.data.data);

            this.servicesListByCategory = response.data.data

            // this.productsListByCategory.products.forEach(function (element) {
            //     element.number = "1";
            // });
          })
          .catch(error => {
            console.log(error);
            this.errored = true
          })
          .finally(() => this.loading = false);

    },

    dateInOut() {
      return this.order.date
    },

    inputEdit(id) {
      document.getElementById(`showInput` + id).style.display = 'block'

    },

    hideInput(id) {
      document.getElementById(`showInput` + id).style.display = 'none'
    },

    spliceNumber(number) {
      //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

      // $("input[data-type='number']").keyup(function (event) {
      //     var $this = $(this);
      //     var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
      //     $this.val(num2);
      // });
      if (number != null) {
        return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
      }
    },

    momentjalaliVue() {
      // this.mintimeMoment = moment(new Date, "HH:mm").format("HH:mm");
      this.dateNow = document.getElementById("mintime").innerHTML
    },

    setEndTime() {
      this.end_time = this.order.start_at;
      console.log(this.end_time);

    },

    setPerson(personId, serviceId) {

      this.order.services.find(x => x.service_id == serviceId).person_id = personId;

      console.log(this.order.services);

    },

    pluck(array, key) {
      return array.map(function (obj) {
        return obj[key];
      });
    },

    addService(id, personId, time, $event, price, name, num, item, accounting_code_id) {

      if (this.pluck(this.order.services, 'service_id').includes(id)) {
        //this.order.services.splice(this.order.services.findIndex(x => x.service_id == id));

        this.order.services = $.grep(this.order.services, function (e) {
          return e.service_id != id;
        });
        console.log(this.order.services);

      } else {


        var priceF = price
        if (!priceF)
          priceF = 0

        if (typeof priceF == 'number') {

        } else {
          priceF = priceF.replace(',', '')
        }


        // if(APP_TYPE == 'Health'){
        //     var noteDetail = name + " - درجه/حجم: "
        //
        // }else
        var noteDetail = ''


        if (typeof num == 'number' || num == '')
          num = '1'


        this.order.services.push({
          service_id: id,
          person_id: personId,
          note: noteDetail,
          num: num,
          price: priceF,
          item: item,

          accounting_code_id: accounting_code_id,

        });

        console.log('order.services');
        console.log(this.order.services);

        /// for items
        this.items = $.grep(this.items, function (e) {
          return e.id != id;
        });

        $('#service-by-cat-' + id).hide();

      }


      const checked = $event.target.checked
      if (checked) {
        this.end_time = moment(this.end_time, "HH:mm").add(time, 'm').format("HH:mm");
        this.order.end_at = this.end_time;

      } else {
        this.end_time = moment(this.end_time, "HH:mm").subtract(time, 'm').format("HH:mm");
        this.order.end_at = this.end_time;
      }


    },

    removeService(item) {

      this.items.push(item);

      this.order.services = $.grep(this.order.services, function (e) {
        return e.service_id != item.id;
      });
      $('#service-by-cat-' + item.id).show();

    },

    addProduct(id, unit, price, $event, name, num, product, accounting_code_id) {
      if (this.pluck(this.order.products, 'product_id').includes(id)) {
        this.order.products = $.grep(this.order.products, function (e) {

          return e.product_id != id;
          //                        console.log(this.order.products);
        })
      } else {


        var priceF = price
        if (!priceF)
          priceF = 0

        if (typeof priceF == 'number') {

        } else {
          priceF = priceF.replace(',', '')

        }

        if (typeof num == 'number' || num == '' || num == null)
          num = '1'

        this.order.items.push({
          product_id: id,
          unit: unit,
          amount: num,
          // note: name + ' ('+this.filteritemType(unit)+')',
          note: '',
          price: priceF,
          item: product,

          accounting_code_id: accounting_code_id,
          end: '',


        })
        console.log(this.order.products);


        /// for items
        // this.products = $.grep(this.products, function (e) {
        //     return e.id != id;
        // });
        $('#product-by-cat-' + id).hide();
        $('#vendor-product-items-' + id).hide();


      }


    },


    addProductEmpty() {

      this.order.items.push({

        id: Math.floor(Math.random() * 1000),
        product: {
          code: null,
          name: null,
          unit: {
            code: null,
            name: null
          }
        },
        amount: 0,
        price: 0,
        discount: 0,
        tax: 0,
        otherCharges: 0,
        detail: null

      })


    },

    removeProduct(id) {

      // this.products.push(item);

      this.order.items = $.grep(this.order.items, function (e) {
        return e.id != id;
      });

      // $('#product-by-cat-' + item.id).show();
      // $('#vendor-product-items-' + item.id).show();

    },

    saveForm() {

      var app = this;
      var newItem = app.order;
      if (newItem.services.length == 0) {
        app.$snotify.warning(app.$t('The service is not selected correctly'));
      } else {
        app.loader = true
        axios.post('/api/orders/add/step1', newItem, app.auth)
            .then(function (resp) {
              app.$snotify.info('ثبت با موفقیت انجام شد');

              app.$router.push({
                path: '/setPersons/' + resp.data.data,
                params: {
                  id: resp.data.data,
                  order: newItem.start_at
                }
              });
              app.loader = false
              //                        console.log(resp.data.data);

            })
            .catch(function (e) {
              app.loader = false
              if (e.response.data.message == 'service is not avaliable in this date') {
                app.$snotify.warning(app.$t('There is no blank expert on the selected date'));
              } else if (e.response.data.message == 'The given data was invalid') {

              } else if (e.response.data.message == 'service is not avaliable in this date') {
                app.$snotify.warning(app.$t('There is no blank expert on the selected date'));
              } else if (e.response.data.message.includes('has not avaliable in this date')) {
                app.$snotify.warning(app.$t('There is no blank expert on the selected date'));
              } else if (e.response.data.message.includes('product has not available amount')) {
                app.$snotify.warning(app.$t('Selected product inventory is running out'));
              } else {
                app.$snotify.warning(e.response.data.message);
              }


              console.log(e.response.data.message);


              app.errors.push(e.response.data.messages);

              //                            app.$snotify.warning('اطلاعات به درستی وارد نشده است');
              console.log(Object.entries(app.errors));

              for (let value of Object.entries(app.errors[0])) {
                //                        for (let error of Object.entries(value[1])) {

                app.$snotify.warning(value[1], {
                  timeout: 7000,
                  //                                    showProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true
                });

                //                        }
              }

            });


      }


    },

    savequick() {

      var app = this;
      var newItem = app.order;
      if (
          (newItem.state != "type2" && newItem.buyer.nationalCode == null) ||

          newItem.factorDate == null ||

          newItem.items[0].amount == null ||
          newItem.items[0].price == null ||
          newItem.items[0].product.name == null ||
          newItem.items[0].product.code == null ||
          newItem.items[0].product.unit.name == null ||
          newItem.items[0].product.unit.code == null ||

          newItem.companyId == null) {
        app.$snotify.warning("فیلدها به درستی وارد نشده است.");
      } else {

        axios.post('v2/api/factor-service/factors', newItem, app.auth)
            .then(function (resp) {
              app.$snotify.info('ثبت انجام شد');


              app.$router.push({
                path: '/order/'
              });

              // app.$router.push({
              //     path: '/order/payment/' + resp.data.data.id,
              //     params: {
              //         id: resp.data.data.id,
              //         order: newItem.start_at
              //     }
              // });
              //                        console.log(resp.data.data);

            })
            .catch(function (e) {
              const qs = require('qs');
              const config = {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
              if (e.response.status === 401) {
                let userData = {
                  grant_type: "refresh_token",
                  client_id: "cyan-business",
                  client_secret: "v4lyYR70VzyDtcKwYm7hKw9O4HB2jtoK",
                  refresh_token: localStorage.getItem('refresh_token'),
                }
                axios.post('realms/cyan/protocol/openid-connect/token', qs.stringify(userData), config)
                    .then(function (response) {
                      localStorage.setItem('token', response.data.access_token);
                      localStorage.setItem('refresh_token', response.data.refresh_token);
                      app.$snotify.warning("مجدد تلاش کنید");
                    })
                    .catch(function (e) {
                      console.log(e.response);
                      // if (e.response.status === 400)
                        app.logout();
                      app.$snotify.error("بروز خطا");

                    });
              } else {
                app.$snotify.error("بروز خطا");
                app.$snotify.warning(e.response.data.message);

              }


              // if (e.response.data.message == 'service is not avaliable in this date') {
              //     app.$snotify.warning(app.$t('There is no blank expert on the selected date'));
              // } else if (e.response.data.message == 'The given data was invalid') {
              //
              // } else if (e.response.data.message == 'service is not avaliable in this date') {
              //     app.$snotify.warning(app.$t('There is no blank expert on the selected date'));
              // } else if (e.response.data.message.includes('has not avaliable in this date')) {
              //     app.$snotify.warning(app.$t('There is no blank expert on the selected date'));
              // } else {
              //     app.$snotify.warning(e.response.data.message);
              // }
              //
              //
              // console.log(e.response);
              //
              //
              //
              // app.errors.push(e.response.data.messages);
              //
              // //                            app.$snotify.warning('اطلاعات به درستی وارد نشده است');
              // console.log(Object.entries(app.errors));
              //
              // for (let value of Object.entries(app.errors[0])) {
              //     //                        for (let error of Object.entries(value[1])) {
              //
              //     app.$snotify.warning(value[1], {
              //         timeout: 7000,
              //         //                                    showProgressBar: false,
              //         closeOnClick: true,
              //         pauseOnHover: true
              //     });
              //
              //     //                        }
              // }

            });
      }


    },

    //            pagnation(api) {
    //                // console.log(api,"m")
    //                axios.get(api, this.auth)
    //                    .then(response => {
    //                        // this.current_page = response.data.current_page
    //                        this.items = response.data.data;
    //                        //  console.log(response.data.data)
    //                        // this.pagnationDate = response.data
    //                        //  console.log(this.pagnationDate)
    //                    })
    //                    .catch(error => {
    //                        console.log(error);
    //                        this.errored = true
    //                    })
    //                    .finally(() => this.loading = false)
    //            },

    totalSum(items) {

      var total = 0;

      console.log(this.pluck(items, 'price'))

      this.pluck(items, 'price').forEach(function (element) {
        console.log(element)

        total = Number(total) + Number(element)


      })


      return total;

    },

    totalSumWithAmount(items) {

      var total = 0;

      console.log(this.pluck(items, 'price'))

      items.forEach(function (element) {
        console.log(element)

        total = Number(total) + Number(element.price * element.amount)


      })


      return total;

    },

    getValue: function () {
      console.log(1);
    },


    getUnits() {
      axios
          .get('/api/unitList', this.auth)
          .then(response => {

            this.units = response.data;
          })
          .catch(error => {
            console.log(error);
            this.errored = true
          })
    },

    getProjects() {
      axios
          .get('/api/projectList', this.auth)
          .then(response => {

            this.projects = response.data;
          })
          .catch(error => {
            console.log(error);
            this.errored = true
          })
    },

    getContacts() {

      axios.get('/api/contactslist', this.auth)
          .then(response => {
            // this.current_page = response.data.current_page
            this.contacts = response.data;
            console.log('contacts', response.data)
            // this.pagnationDate = response.data
            // console.log(this.pagnationDate)
            // this.loader = false

            // this.makeContactOptions()

          })
          .catch(error => {
            // this.loader = false
            console.log(error);
          })
    },

    makeContactOptions() {
      var app = this;

      for (const key in app.contacts) {
        if (app.contacts.hasOwnProperty(key)) {
          const element = app.contacts[key];

          app.contactOptions.push({
            value: element.id,
            text: element.first_name + ' ' + element.last_name
          })
          // this.details[0].
        }
      }
      console.log(app.contacts)
      console.log(app.contactOptions)


    },

    getAccountingCodes() {

      axios.get('/api/accountingCodesList', this.auth)
          .then(response => {
            // this.current_page = response.data.current_page
            this.accountingCodes = response.data.data;
            console.log('accountingCodes', response.data.data)
            // this.pagnationDate = response.data
            // console.log(this.pagnationDate)
            // this.loader = false

            // this.makeContactOptions()

          })
          .catch(error => {
            // this.loader = false
            console.log(error);
          })
    },

    filteritemType(item) {

      var unit = null
      if (unit = this.units.find(x => x.id == item))
        return unit.title
      else return 'نامشخص'

      // switch (item) {
      //     case '0':
      //         return  this.$t('Number')
      //         break;
      //     case '1':
      //         return  this.$t('g')
      //         break;
      //     case '2':
      //         return  this.$t('Kg')
      //         break;
      //     case '3':
      //         return   this.$t('Liter')
      //         break;
      //     case '4':
      //         return  this.$t('packet')
      //         break;
      //     default:
      //         return  this.$t('Unknown')
      // }
    },

    getVendorProducts(contactId) {
      let app = this;

      axios.get('/api/vendor/products/' + contactId, app.auth)
          .then(response => {
            app.vendorProducts = response.data.data;

            var vendorProductsItems = app.allProducts

            app.vendorProducts.forEach(function (element) {
              if (vendorProductsItems.find(x => x.id == element.product_id))
                vendorProductsItems.find(x => x.id == element.product_id).price = element.price
            });

            ///temp code: need to consider ... must be merge together
            vendorProductsItems.forEach(function (element) {
              if (!app.vendorProducts.find(x => x.product_id == element.id))
                vendorProductsItems = $.grep(vendorProductsItems, function (e) {
                  return e.id != element.id;
                });
            });

            app.products = vendorProductsItems

          })
          .catch(error => {
            console.log(error);
          })

    },


    productShowName(ProductId) {
      return this.allProducts.find(x => x.id == ProductId).title
    },

    serviceShowName(serviceId) {
      if (serviceId)
        return this.allServices.find(x => x.id == serviceId).title
    },


    accountingCodeShowName(id) {
      if (id)
        return this.accountingCodes.find(x => x.id == id).code
    },

    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('id');
      localStorage.removeItem('name');
      localStorage.removeItem('family');
      localStorage.removeItem('email');
      localStorage.removeItem('state');
      localStorage.removeItem('role');
      localStorage.removeItem('roles');
      // axios.get('/api/auth/logout', this.auth);
      this.$router.push({
        path: '/login'
      });

    }



  }
}

</script>

<style>
/* This css is for normalizing styles. You can skip this. */
*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.btn-pur {
  background-color: #00acc1;
  color: white;
  outline: 0;
}

.btn-pur:hover,
.btn-pur:focus {
  background-color: #7853d1;
  color: white
}


.new {
  padding: 50px;
}

.form-group2 {
  display: block;
  margin-bottom: 15px;
}

.form-group2 input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.form-group2 label {
  position: relative;
  cursor: pointer;
}

.form-group2 label:before {
  content: '';
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid lightgray;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
}

.form-group2 input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 2px;
  right: 13px;
  width: 8px;
  height: 14px;
  border: solid #d54e21;
  border-width: 0 4px 4px 0;
  transform: rotate(45deg);
}

.form-group3 label:before {
  content: '';
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid lightgray;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
}

.form-group3 input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 2px;
  right: 13px;
  width: 8px;
  height: 14px;
  border: solid #d54e21;
  border-width: 0 4px 4px 0;
  transform: rotate(45deg);
}


@keyframes click-wave {
  0% {
    height: 40px;
    width: 40px;
    opacity: 0.35;
    position: relative;
  }

  100% {
    height: 200px;
    width: 200px;
    margin-left: -80px;
    margin-top: -80px;
    opacity: 0;
  }
}

.option-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 20px;
  width: 20px;
  transition: all 0.15s ease-out 0s;
  background: #cbd1d8;
  border: none;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  margin-right: 0.5rem;
  outline: none;
  position: relative;
  z-index: 0;
  vertical-align: bottom;
  margin: 0 !important;
}

.option-input:hover {
  background: #9faab7;
}

.option-input:checked {
  background: #40e0d0;
}

.option-input:checked::before {
  height: 20px;
  width: 20px;
  position: absolute;
  content: '✔';
  display: inline-block;
  /* font-size: 26.66667px; */
  text-align: center;
  /* line-height: 40px; */
}

/*.option-input:checked::after {*/
/*-webkit-animation: click-wave 0.65s;*/
/*-moz-animation: click-wave 0.65s;*/
/*animation: click-wave 0.65s;*/
/*background: #40e0d0;*/
/*content: '';*/
/*display: block;*/
/*position: relative;*/
/*z-index: 100;*/
/*outline: 0;*/
/*}*/

input[type=file]:focus,
input[type=checkbox]:focus,
input[type=radio]:focus {
  outline: 0 !important;
}

.flat-red {
  z-index: 0;

}


.multi-steps > li.is-active:before,
.multi-steps > li.is-active ~ li:before {
  content: counter(stepNum);
  font-family: inherit;
  font-weight: 700;
}

.multi-steps > li.is-active:after,
.multi-steps > li.is-active ~ li:after {
  background-color: #ededed;
}

.multi-steps {
  position: relative;
  display: table;
  table-layout: fixed;
  width: 100%;
  z-index: 11;
}

.multi-steps > li {
  counter-increment: stepNum;
  text-align: center;
  display: table-cell;
  position: relative;
  color: tomato;
}

.multi-steps > li:before {
  content: '\f00c';
  content: '\2713;';
  content: '\10003';
  content: '\10004';
  content: '\2713';
  display: block;
  margin: 0 auto 4px;
  background-color: #fff;
  width: 36px;
  height: 36px;
  line-height: 32px;
  text-align: center;
  font-weight: bold;
  border-width: 2px;
  border-style: solid;
  border-color: tomato;
  border-radius: 50%;
}

.multi-steps > li:after {
  content: '';
  height: 2px;
  width: 100%;
  background-color: red;
  position: absolute;
  top: 16px;
  right: 50%;
  z-index: -1;
}

.multi-steps > li:last-child:after {
  display: none;
}

.multi-steps > li.is-active:before {
  background-color: #fff;
  border-color: tomato;
}

.multi-steps > li.is-active ~ li {
  color: #808080;
}

.multi-steps > li.is-active ~ li:before {
  background-color: #ededed;
  border-color: #ededed;
}


.box-o {
  border-radius: 4px;
  box-shadow: 0 0 3px rgba(0, 0, 0, .5);

}

</style>
